/** Public business-model (USP #7) — latest published revenue breakdown. */
import { apiRequest } from '@/lib/api'

export interface PublicRevenueFigure {
  period: string
  currency: string
  subscriptions_cents: number
  interchange_cents: number
  fx_margin_cents: number
  paylink_cents: number
  total_cents: number
  published_at: string | null
}

export const businessApi = {
  getRevenue: () =>
    apiRequest<{ figure: PublicRevenueFigure | null }>('/business-model/figures', { auth: false }),
}
